import { GrupoNoticiaDTO } from './grupoNoticiaDTO';
import { ArquivoDTO } from '../arquivoDTO';

export class NoticiaDTO{

    
    id!: number;
    dataCriacao!: Date;
    dataPublicacao!: Date;
    grupo!: GrupoNoticiaDTO;
    status!:string;
    banner!:ArquivoDTO;
    bannerReduzido!: ArquivoDTO;
    titulo!:string;
    subtitulo!:string;
    texto!:string;
    resumo!: string;
    publicarNaHome!: boolean;
    destacar!: boolean;
    galeriaFotos!: ArquivoDTO[];
    galeriaDownloads!: ArquivoDTO[];
    galeriaVideos!: ArquivoDTO[];
    
    // Propriedade auxiliar para a entrada de tags como string
    tagsInput?: string;

    // Propriedade que armazena as tags como array de strings (após processamento, removendo duplicatas e espaços)
    tags?: string[];

    // Propriedade para o Title Tag (máximo 60 caracteres)
    titleTag?: string;

    // Propriedade para a Meta Description (máximo 160 caracteres)
    metaDescription?: string;
}


